import * as React from "react";
import { useMemo, useContext } from "react";
import styled, { css } from "styled-components";
import TableFetchContext from "components/common/PaginatedEntityTable/TableFetchContext";
import SliceHeaderControls from "./SliceHeaderControls";
import { DEFAULT_SORT_OPTIONS } from "./SliceFilters";
import SlicesOverview from "./SlicesOverview";
const Container = styled.div(
  ({ theme }) => css`
    width: 400px;
    border-right: 1px solid ${theme.colors.gray[90]};
    padding-right: ${theme.spacings.sm};
  `
);
const Slicing = ({ appSection, columnSchemas, onChangeSlicing, sliceRenderers = void 0, fetchSlices }) => {
  const {
    searchParams: { sliceCol, slice: activeSlice }
  } = useContext(TableFetchContext);
  const activeColumn = columnSchemas.find(({ id }) => id === sliceCol);
  const sortOptions = useMemo(
    () => {
      var _a, _b;
      return [
        ...DEFAULT_SORT_OPTIONS,
        ...(_b = (_a = activeColumn == null ? void 0 : activeColumn.slice_sort_options) == null ? void 0 : _a.map((option) => ({ value: option.value, label: option.title }))) != null ? _b : []
      ];
    },
    [activeColumn]
  );
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(
    SliceHeaderControls,
    {
      appSection,
      activeColumnTitle: activeColumn == null ? void 0 : activeColumn.title,
      activeSlice,
      sliceCol,
      columnSchemas,
      onChangeSlicing
    }
  ), /* @__PURE__ */ React.createElement(
    SlicesOverview,
    {
      key: sliceCol != null ? sliceCol : "no-slice",
      appSection,
      sliceCol,
      activeSlice,
      activeColumnTitle: activeColumn == null ? void 0 : activeColumn.title,
      onChangeSlicing,
      sliceRenderers,
      fetchSlices,
      sortOptions
    }
  ));
};
export default Slicing;
